/**
 * Sokora Custom Article Page — Interactive Features
 * Reading progress, TOC generation, share, like/bookmark, more reads nav
 */
(function() {
  'use strict';

  // Wait for DOM
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    setupReadingProgress();
    setupTOC();
    setupLikeButton();
    setupBookmarkButton();
    setupShareButtons();
    setupMoreReadsNav();
  }

  /* ===== READING PROGRESS ===== */
  function setupReadingProgress() {
    var progressBar = document.getElementById('sk-reading-progress');
    var percentLabel = document.getElementById('sk-read-percent');
    var articleContent = document.getElementById('sk-article-content');

    if (!progressBar || !articleContent) return;

    function updateProgress() {
      var rect = articleContent.getBoundingClientRect();
      var contentTop = rect.top + window.scrollY;
      var contentHeight = rect.height;
      var scrolled = window.scrollY - contentTop + window.innerHeight * 0.3;
      var percent = Math.min(100, Math.max(0, (scrolled / contentHeight) * 100));

      progressBar.style.width = Math.round(percent) + '%';
      if (percentLabel) {
        percentLabel.textContent = Math.round(percent) + '% READ';
      }
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  /* ===== TABLE OF CONTENTS ===== */
  function setupTOC() {
    var articleContent = document.getElementById('sk-article-content');
    var tocDesktop = document.getElementById('sk-toc-list-desktop');
    var tocMobile = document.getElementById('sk-toc-list-mobile');

    if (!articleContent) return;

    // Find all h2 headings inside article content
    var headings = articleContent.querySelectorAll('h2');
    if (headings.length === 0) return;

    // Generate TOC items
    headings.forEach(function(heading, index) {
      // Add ID to heading for scroll targeting
      if (!heading.id) {
        heading.id = 'sk-heading-' + index;
      }

      var text = heading.textContent.trim();

      // Create button for desktop TOC
      if (tocDesktop) {
        var btnDesktop = document.createElement('button');
        btnDesktop.className = 'sk-article__toc-item';
        btnDesktop.textContent = text;
        btnDesktop.setAttribute('data-target', heading.id);
        btnDesktop.addEventListener('click', function() {
          scrollToHeading(heading.id);
        });
        tocDesktop.appendChild(btnDesktop);
      }

      // Create button for mobile TOC
      if (tocMobile) {
        var btnMobile = document.createElement('button');
        btnMobile.className = 'sk-article__toc-item';
        btnMobile.textContent = text;
        btnMobile.setAttribute('data-target', heading.id);
        btnMobile.addEventListener('click', function() {
          scrollToHeading(heading.id);
        });
        tocMobile.appendChild(btnMobile);
      }
    });

    // Highlight active TOC item on scroll
    function updateActiveTOC() {
      var scrollPos = window.scrollY + 120;
      var activeId = '';

      headings.forEach(function(heading) {
        if (heading.offsetTop <= scrollPos) {
          activeId = heading.id;
        }
      });

      // Update desktop TOC
      if (tocDesktop) {
        tocDesktop.querySelectorAll('.sk-article__toc-item').forEach(function(btn) {
          btn.classList.toggle('active', btn.getAttribute('data-target') === activeId);
        });
      }

      // Update mobile TOC
      if (tocMobile) {
        tocMobile.querySelectorAll('.sk-article__toc-item').forEach(function(btn) {
          btn.classList.toggle('active', btn.getAttribute('data-target') === activeId);
        });
      }
    }

    window.addEventListener('scroll', updateActiveTOC, { passive: true });
    updateActiveTOC();
  }

  function scrollToHeading(id) {
    var el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* ===== LIKE BUTTON ===== */
  function setupLikeButton() {
    var likeBtn = document.getElementById('sk-like-btn');
    var likeCount = document.getElementById('sk-like-count');
    if (!likeBtn || !likeCount) return;

    var articleId = window.location.pathname;
    var storageKey = 'sk_liked_' + articleId;
    var countKey = 'sk_like_count_' + articleId;

    // Load from localStorage
    var isLiked = localStorage.getItem(storageKey) === 'true';
    var count = parseInt(localStorage.getItem(countKey)) || 0;

    if (isLiked) {
      likeBtn.classList.add('active');
    }
    likeCount.textContent = count;

    likeBtn.addEventListener('click', function() {
      isLiked = !isLiked;
      count = isLiked ? count + 1 : Math.max(0, count - 1);

      localStorage.setItem(storageKey, isLiked);
      localStorage.setItem(countKey, count);

      likeBtn.classList.toggle('active', isLiked);
      likeCount.textContent = count;
    });
  }

  /* ===== BOOKMARK BUTTON ===== */
  function setupBookmarkButton() {
    var bookmarkBtn = document.getElementById('sk-bookmark-btn');
    if (!bookmarkBtn) return;

    var articleId = window.location.pathname;
    var storageKey = 'sk_bookmarked_' + articleId;

    var isBookmarked = localStorage.getItem(storageKey) === 'true';
    if (isBookmarked) {
      bookmarkBtn.classList.add('active');
    }

    bookmarkBtn.addEventListener('click', function() {
      isBookmarked = !isBookmarked;
      localStorage.setItem(storageKey, isBookmarked);
      bookmarkBtn.classList.toggle('active', isBookmarked);
    });
  }

  /* ===== SHARE BUTTONS ===== */
  function setupShareButtons() {
    // Header share button (copy link)
    var headerShareBtn = document.getElementById('sk-share-btn');
    if (headerShareBtn) {
      headerShareBtn.addEventListener('click', function() {
        copyToClipboard(headerShareBtn.getAttribute('data-url'));
      });
    }

    // Bottom copy link button
    var copyLinkBtn = document.getElementById('sk-copy-link-btn');
    if (copyLinkBtn) {
      copyLinkBtn.addEventListener('click', function() {
        copyToClipboard(copyLinkBtn.getAttribute('data-url'));
      });
    }
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function() {
        showToast('Link copied!');
      });
    } else {
      // Fallback
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      showToast('Link copied!');
    }
  }

  function showToast(message) {
    var existing = document.querySelector('.sk-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'sk-toast';
    toast.textContent = message;
    toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#8741a4;color:white;padding:10px 20px;border-radius:12px;font-size:13px;font-weight:700;z-index:9999;box-shadow:0 4px 12px rgba(135,65,164,0.4);animation:sk-toast-in 0.3s ease;';
    document.body.appendChild(toast);

    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.3s';
      setTimeout(function() { toast.remove(); }, 300);
    }, 2000);
  }

  /* ===== MORE READS NAVIGATION ===== */
  function setupMoreReadsNav() {
    var container = document.getElementById('sk-more-reads-container');
    var prevBtn = document.getElementById('sk-more-prev');
    var nextBtn = document.getElementById('sk-more-next');

    if (!container || !prevBtn || !nextBtn) return;

    var scrollAmount = 320;

    prevBtn.addEventListener('click', function() {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function() {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

})();
